export const DefinedAxiosInstances = {
    V1: {
        name: "V1",
        urlPostFix: "/v1",
    },
    V2: {
        name: "V2",
        urlPostFix: "/v2",
    },
    V3: {
        name: "V3",
        urlPostFix: "/v3",
    },
    // Public, unauthenticated reads (e.g. branding config, NG-8457). Targets the v3 public namespace but
    // is created WITHOUT the shared auth interceptors (see createInstances in Axios.ts).
    PUBLIC: {
        name: "PUBLIC",
        urlPostFix: "/v3",
    },
    // NG-8648: the downstream environment provisioned during developer registration. Created only
    // when SANDBOX_API_BASE_URL is configured, and — like PUBLIC — WITHOUT the shared auth interceptors
    // (see createInstances in Axios.ts). The downstream session must never reach the shared token
    // store, which is keyed by tenant id alone and would collide across environments, so every call
    // on these instances passes its bearer explicitly.
    SANDBOX_V2: {
        name: "SANDBOX_V2",
        urlPostFix: "/v2",
    },
    SANDBOX_V3: {
        name: "SANDBOX_V3",
        urlPostFix: "/v3",
    },
    graphqlInstance: {
        name: "graphqlInstance",
    },
    NOV: {
        name: "NOV",
        urlPostFix: "/",
    },
    AUTH: {
        name: "AUTH",
        urlPostFix: "auth",
    },
};
